var _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBusinessSvg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_2849_758",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_2849_758)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17 21C15.8858 21 14.9407 20.6119 14.1645 19.8355C13.3882 19.0594 13 18.1142 13 17C13 15.8859 13.3882 14.9407 14.1645 14.1645C14.9407 13.3882 15.8858 13 17 13C18.1142 13 19.0593 13.3882 19.8355 14.1645C20.6118 14.9407 21 15.8859 21 17C21 18.1142 20.6118 19.0594 19.8355 19.8355C19.0593 20.6119 18.1142 21 17 21ZM12 20.9615C9.991 20.3654 8.32208 19.1484 6.99325 17.3105C5.66442 15.4727 5 13.4025 5 11.1V5.69228L12 3.07703L19 5.69228V11.348C18.7205 11.234 18.3997 11.1475 18.0375 11.0885C17.6753 11.0295 17.3295 11 17 11C15.3358 11 13.9198 11.584 12.752 12.752C11.584 13.9199 11 15.3359 11 17C11 17.6872 11.1157 18.3577 11.347 19.0115C11.5785 19.6654 11.9237 20.2686 12.3828 20.8213C12.3148 20.8468 12.2509 20.8701 12.1912 20.8913C12.1317 20.9124 12.068 20.9359 12 20.9615ZM17 17C17.4167 17 17.7708 16.8542 18.0625 16.5625C18.3542 16.2709 18.5 15.9167 18.5 15.5C18.5 15.0834 18.3542 14.7292 18.0625 14.4375C17.7708 14.1459 17.4167 14 17 14C16.5833 14 16.2292 14.1459 15.9375 14.4375C15.6458 14.7292 15.5 15.0834 15.5 15.5C15.5 15.9167 15.6458 16.2709 15.9375 16.5625C16.2292 16.8542 16.5833 17 17 17ZM17 20C17.5295 20 18.0077 19.8824 18.4345 19.647C18.8615 19.4119 19.2148 19.0943 19.4943 18.6943C19.1147 18.4648 18.7167 18.2917 18.3 18.175C17.8833 18.0584 17.45 18 17 18C16.55 18 16.1167 18.0584 15.7 18.175C15.2833 18.2917 14.8853 18.4648 14.5057 18.6943C14.7852 19.0943 15.1385 19.4119 15.5655 19.647C15.9923 19.8824 16.4705 20 17 20Z",
    fill: "black"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBusinessSvg);
export default __webpack_public_path__ + "static/media/businessSvg.0d58a7f9fdacc6ec58d4ed2adc531011.svg";
export { ForwardRef as ReactComponent };